import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/icon-open-explorer.svg")